import { c as _c } from "react/compiler-runtime";
import React, { useCallback, useId } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleUp, faAngleDown } from "@fortawesome/free-solid-svg-icons";
import type { MakeModelSelectorProps } from "@/types/searchSide";
const ExtractNameAndCount: React.FC<{
  carString: string;
}> = t0 => {
  const $ = _c(10);
  const {
    carString
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = /^(.+?)\s*\((\d+)\)$/;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const regex = t1;
  let t2;
  if ($[1] !== carString) {
    t2 = carString.match(regex);
    $[1] = carString;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const match = t2;
  let carName = "";
  let carCount = "";
  if (match) {
    carName = match[1] || "";
    carCount = `(${match[2]})`;
  }
  let t3;
  if ($[3] !== carName) {
    t3 = <span className="t-truncate t-text-[#5e5864]">{carName}</span>;
    $[3] = carName;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== carCount) {
    t4 = <span className="t-flex-shrink-0 t-text-[10px] t-text-[#928c96]">{carCount}</span>;
    $[5] = carCount;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = <div className="t-flex t-w-full t-min-w-0 t-items-center t-justify-between t-gap-2">{t3}{t4}</div>;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
};
const ClearButton: React.FC<{
  onClear: (e?: React.MouseEvent | React.KeyboardEvent) => void;
  count: number;
}> = t0 => {
  const $ = _c(9);
  const {
    onClear,
    count
  } = t0;
  let t1;
  if ($[0] !== onClear) {
    t1 = e => onClear(e);
    $[0] = onClear;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = `Clear ${count} selections`;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <svg className="t-w-3.5 t-h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" /></svg>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== count) {
    t4 = <span>Clear {count}</span>;
    $[3] = count;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t1 || $[6] !== t2 || $[7] !== t4) {
    t5 = <button type="button" className="t-inline-flex t-items-center t-gap-1 t-text-xs t-font-semibold t-text-automotive-primary hover:t-text-automotive-secondary t-transition-colors focus:t-outline-none focus:t-ring-2 focus:t-ring-automotive-primary focus:t-ring-offset-2 t-rounded" onClick={t1} aria-label={t2}>{t3}{t4}</button>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
};
const ChevronIcon: React.FC<{
  isExpanded: boolean;
}> = t0 => {
  const $ = _c(3);
  const {
    isExpanded
  } = t0;
  const t1 = `t-w-4 t-h-4 t-text-gray-400 t-transition-transform t-duration-200 ${isExpanded ? "t-rotate-90" : ""}`;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== t1) {
    t3 = <svg className={t1} fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">{t2}</svg>;
    $[1] = t1;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  return t3;
};
const CheckboxIcon: React.FC<{
  isSelected: boolean;
  isPartiallySelected?: boolean;
  className?: string;
}> = t0 => {
  const $ = _c(8);
  const {
    isSelected,
    isPartiallySelected,
    className: t1
  } = t0;
  const className = t1 === undefined ? "" : t1;
  if (isPartiallySelected) {
    const t2 = `t-w-4 t-h-4 t-border-2 t-border-brand-violet t-rounded t-bg-brand-lavender t-flex t-items-center t-justify-center ${className}`;
    let t3;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <div className="t-w-2 t-h-0.5 t-bg-brand-violet t-rounded" />;
      $[0] = t3;
    } else {
      t3 = $[0];
    }
    let t4;
    if ($[1] !== t2) {
      t4 = <div className={t2}>{t3}</div>;
      $[1] = t2;
      $[2] = t4;
    } else {
      t4 = $[2];
    }
    return t4;
  }
  const t2 = `t-w-4 t-h-4 t-border-2 t-rounded t-flex t-items-center t-justify-center ${isSelected ? "t-border-brand-violet t-bg-brand-violet" : "t-border-gray-300 t-bg-white"} ${className}`;
  let t3;
  if ($[3] !== isSelected) {
    t3 = isSelected && <svg className="t-w-3 t-h-3 t-text-white" fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" /></svg>;
    $[3] = isSelected;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <div className={t2}>{t3}</div>;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
};
export const MakeModelSelector: React.FC<MakeModelSelectorProps> = t0 => {
  const $ = _c(64);
  const {
    makes,
    selectedMakes,
    selectedModels,
    allModels,
    expandedMakes,
    onMakeChange,
    onModelChange,
    onMakeModelChange,
    onMakeToggle,
    onClearMakes,
    onClearModels,
    onClearMakeModels,
    isOpen,
    onToggle,
    className: t1,
    "aria-label": ariaLabel
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const sectionId = useId();
  const triggerId = `make-model-${sectionId}-trigger`;
  const contentId = `make-model-${sectionId}-content`;
  const addDefaultSrc = _temp;
  let t2;
  if ($[0] !== allModels) {
    t2 = make => {
      const makeGroup = allModels.find(group => group.label === make);
      return makeGroup ? makeGroup.options : [];
    };
    $[0] = allModels;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const getModelsForMake = t2;
  let t3;
  if ($[2] !== getModelsForMake || $[3] !== selectedModels) {
    t3 = make_0 => {
      const makeModels = getModelsForMake(make_0);
      const selectedModelsForMake = makeModels.filter(model => selectedModels.includes(model.value));
      return selectedModelsForMake.length > 0 && selectedModelsForMake.length < makeModels.length;
    };
    $[2] = getModelsForMake;
    $[3] = selectedModels;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const isMakePartiallySelected = t3;
  let t4;
  if ($[5] !== getModelsForMake || $[6] !== onMakeChange || $[7] !== onMakeModelChange || $[8] !== onModelChange || $[9] !== selectedMakes || $[10] !== selectedModels) {
    t4 = make_1 => {
      const isMakeSelected = selectedMakes.includes(make_1);
      if (onMakeModelChange) {
        const makes_0 = isMakeSelected ? selectedMakes.filter(value => value !== make_1) : [...selectedMakes, make_1];
        const modelValues = new Set(getModelsForMake(make_1).map(_temp2));
        const models = isMakeSelected ? selectedModels.filter(model_1 => !modelValues.has(model_1)) : selectedModels;
        onMakeModelChange(makes_0, models);
        return;
      }
      if (isMakeSelected) {
        const newSelectedMakes = selectedMakes.filter(m => m !== make_1);
        onMakeChange(newSelectedMakes);
        const makeModels_0 = getModelsForMake(make_1);
        if (makeModels_0.length > 0 && selectedModels.length > 0) {
          const makeModelValues = new Set(makeModels_0.map(_temp3));
          const prunedModels = selectedModels.filter(m_1 => !makeModelValues.has(m_1));
          if (prunedModels.length !== selectedModels.length) {
            onModelChange(prunedModels);
          }
        }
      } else {
        const newSelectedMakes_0 = [...selectedMakes, make_1];
        onMakeChange(newSelectedMakes_0);
      }
    };
    $[5] = getModelsForMake;
    $[6] = onMakeChange;
    $[7] = onMakeModelChange;
    $[8] = onModelChange;
    $[9] = selectedMakes;
    $[10] = selectedModels;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const handleMakeSelect = t4;
  let t5;
  if ($[12] !== getModelsForMake || $[13] !== onMakeChange || $[14] !== onMakeModelChange || $[15] !== onModelChange || $[16] !== selectedMakes || $[17] !== selectedModels) {
    t5 = (model_2, make_2) => {
      const isModelSelected = selectedModels.includes(model_2);
      const makeModels_1 = getModelsForMake(make_2);
      if (onMakeModelChange) {
        const models_0 = isModelSelected ? selectedModels.filter(value_0 => value_0 !== model_2) : [...selectedModels, model_2];
        const hasModelsForMake = makeModels_1.some(option => models_0.includes(option.value));
        const makes_1 = hasModelsForMake ? selectedMakes.includes(make_2) ? selectedMakes : [...selectedMakes, make_2] : selectedMakes.filter(value_1 => value_1 !== make_2);
        onMakeModelChange(makes_1, models_0);
        return;
      }
      if (isModelSelected) {
        const newSelectedModels = selectedModels.filter(m_2 => m_2 !== model_2);
        onModelChange(newSelectedModels);
        const remainingModelsForMake = makeModels_1.filter(m_3 => m_3.value !== model_2 && newSelectedModels.includes(m_3.value));
        if (remainingModelsForMake.length === 0) {
          const newSelectedMakes_1 = selectedMakes.filter(m_4 => m_4 !== make_2);
          onMakeChange(newSelectedMakes_1);
        }
      } else {
        const newSelectedModels_0 = [...selectedModels, model_2];
        onModelChange(newSelectedModels_0);
        if (!selectedMakes.includes(make_2)) {
          const newSelectedMakes_2 = [...selectedMakes, make_2];
          onMakeChange(newSelectedMakes_2);
        }
      }
    };
    $[12] = getModelsForMake;
    $[13] = onMakeChange;
    $[14] = onMakeModelChange;
    $[15] = onModelChange;
    $[16] = selectedMakes;
    $[17] = selectedModels;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  const handleModelSelect = t5;
  let t6;
  if ($[19] !== onMakeToggle) {
    t6 = (make_3, event) => {
      event.stopPropagation();
      onMakeToggle(make_3);
    };
    $[19] = onMakeToggle;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  const handleMakeToggleClick = t6;
  let t7;
  if ($[21] !== handleMakeSelect) {
    t7 = (make_4, e) => {
      if (e.target !== e.currentTarget) {
        return;
      }
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        handleMakeSelect(make_4);
      }
    };
    $[21] = handleMakeSelect;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  const handleMakeKeyDown = t7;
  const totalSelectedCount = selectedMakes.length + selectedModels.length;
  let t8;
  if ($[23] !== onClearMakeModels || $[24] !== onClearMakes || $[25] !== onClearModels) {
    t8 = e_0 => {
      e_0?.preventDefault?.();
      e_0?.stopPropagation?.();
      if (onClearMakeModels) {
        onClearMakeModels();
        return;
      }
      onClearModels();
      onClearMakes();
    };
    $[23] = onClearMakeModels;
    $[24] = onClearMakes;
    $[25] = onClearModels;
    $[26] = t8;
  } else {
    t8 = $[26];
  }
  const handleClearAll = t8;
  let t9;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <span>{"Make & Model"}</span>;
    $[27] = t9;
  } else {
    t9 = $[27];
  }
  const t10 = isOpen ? faAngleUp : faAngleDown;
  let t11;
  if ($[28] !== t10) {
    t11 = <FontAwesomeIcon icon={t10} className="t-h-4 t-w-4 t-text-[#928c96]" aria-hidden="true" />;
    $[28] = t10;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  let t12;
  if ($[30] !== contentId || $[31] !== isOpen || $[32] !== onToggle || $[33] !== t11 || $[34] !== triggerId) {
    t12 = <button id={triggerId} className="t-flex t-w-full t-items-center t-justify-between t-text-left t-text-sm t-font-extrabold t-text-[#38323d] t-transition-colors hover:t-text-brand-violet focus:t-rounded focus:t-outline-none focus:t-ring-2 focus:t-ring-brand-violet focus:t-ring-offset-2" type="button" onClick={onToggle} aria-expanded={isOpen} aria-controls={contentId}>{t9}{t11}</button>;
    $[30] = contentId;
    $[31] = isOpen;
    $[32] = onToggle;
    $[33] = t11;
    $[34] = triggerId;
    $[35] = t12;
  } else {
    t12 = $[35];
  }
  let t13;
  if ($[36] !== handleClearAll || $[37] !== totalSelectedCount) {
    t13 = totalSelectedCount > 0 && <div className="t-mt-2"><ClearButton onClear={handleClearAll} count={totalSelectedCount} /></div>;
    $[36] = handleClearAll;
    $[37] = totalSelectedCount;
    $[38] = t13;
  } else {
    t13 = $[38];
  }
  let t14;
  if ($[39] !== t12 || $[40] !== t13) {
    t14 = <div>{t12}{t13}</div>;
    $[39] = t12;
    $[40] = t13;
    $[41] = t14;
  } else {
    t14 = $[41];
  }
  let t15;
  if ($[42] !== contentId || $[43] !== expandedMakes || $[44] !== getModelsForMake || $[45] !== handleMakeKeyDown || $[46] !== handleMakeSelect || $[47] !== handleMakeToggleClick || $[48] !== handleModelSelect || $[49] !== isMakePartiallySelected || $[50] !== isOpen || $[51] !== makes || $[52] !== sectionId || $[53] !== selectedMakes || $[54] !== selectedModels || $[55] !== triggerId) {
    t15 = isOpen && <div id={contentId} className="t-mt-4 t-space-y-0.5" role="group" aria-labelledby={triggerId}>{makes.map(make_5 => {
        const isExpanded = expandedMakes.includes(make_5.value);
        const isMakeSelected_0 = selectedMakes.includes(make_5.value);
        const isPartiallySelected = isMakePartiallySelected(make_5.value);
        const makeModels_2 = getModelsForMake(make_5.value);
        const modelsId = `${sectionId}-${make_5.value.toLowerCase().replace(/[^a-z0-9]+/g, "-")}-models`;
        return <div key={make_5.value} className="t-overflow-hidden t-rounded-md"><div role="button" tabIndex={0} onKeyDown={e_1 => handleMakeKeyDown(make_5.value, e_1)} aria-pressed={isMakeSelected_0 || isPartiallySelected} aria-expanded={makeModels_2.length > 0 ? isExpanded : undefined} aria-controls={makeModels_2.length > 0 ? modelsId : undefined} className={`t-flex t-cursor-pointer t-items-center t-px-1 t-py-2 t-transition-colors t-duration-200 ${isMakeSelected_0 || isPartiallySelected ? "t-bg-[#f7f3ff] hover:t-bg-[#f7f3ff]" : "t-bg-white hover:t-bg-[#faf9fb]"}`} onClick={() => handleMakeSelect(make_5.value)}><img src={`/media/maker-icons/${make_5.value.includes(" ") ? make_5.value.replace(/ /g, "-").toLowerCase() : make_5.value.toLowerCase()}.png`} width={20} height={20} onError={addDefaultSrc} alt={`${make_5.value} logo`} className="t-mr-2 t-flex-shrink-0" /><CheckboxIcon isSelected={isMakeSelected_0 && !isPartiallySelected} isPartiallySelected={isPartiallySelected} className="t-mr-2 t-flex-shrink-0" /><div className="t-flex-1"><ExtractNameAndCount carString={make_5.label} /></div>{makeModels_2.length > 0 && <button type="button" className="t-rounded t-p-1 t-transition-colors t-duration-200 hover:t-bg-[#ece8ef]" onClick={e_2 => handleMakeToggleClick(make_5.value, e_2)} aria-expanded={isExpanded} aria-controls={modelsId} aria-label={`${isExpanded ? "Collapse" : "Expand"} ${make_5.value} models`}><ChevronIcon isExpanded={isExpanded} /></button>}</div>{isExpanded && makeModels_2.length > 0 && <div id={modelsId} className="t-ml-7 t-border-l t-border-[#e4e0e6] t-bg-white">{makeModels_2.map(model_3 => {
              const isModelSelected_0 = selectedModels.includes(model_3.value);
              return <button type="button" key={model_3.value} className={`t-flex t-w-full t-cursor-pointer t-items-center t-px-3 t-py-2 t-text-left t-text-[13px] t-transition-colors t-duration-200 ${isModelSelected_0 ? "t-bg-[#f7f3ff] hover:t-bg-[#f7f3ff]" : "hover:t-bg-[#faf9fb]"}`} onClick={() => handleModelSelect(model_3.value, make_5.value)} aria-pressed={isModelSelected_0} aria-label={`${model_3.label} ${isModelSelected_0 ? "selected" : "not selected"}`}><CheckboxIcon isSelected={isModelSelected_0} className="t-mr-2 t-flex-shrink-0" /><ExtractNameAndCount carString={model_3.label} /></button>;
            })}</div>}</div>;
      })}</div>;
    $[42] = contentId;
    $[43] = expandedMakes;
    $[44] = getModelsForMake;
    $[45] = handleMakeKeyDown;
    $[46] = handleMakeSelect;
    $[47] = handleMakeToggleClick;
    $[48] = handleModelSelect;
    $[49] = isMakePartiallySelected;
    $[50] = isOpen;
    $[51] = makes;
    $[52] = sectionId;
    $[53] = selectedMakes;
    $[54] = selectedModels;
    $[55] = triggerId;
    $[56] = t15;
  } else {
    t15 = $[56];
  }
  let t16;
  if ($[57] !== t14 || $[58] !== t15) {
    t16 = <div>{t14}{t15}</div>;
    $[57] = t14;
    $[58] = t15;
    $[59] = t16;
  } else {
    t16 = $[59];
  }
  let t17;
  if ($[60] !== ariaLabel || $[61] !== className || $[62] !== t16) {
    t17 = <div className={className} aria-label={ariaLabel}>{t16}</div>;
    $[60] = ariaLabel;
    $[61] = className;
    $[62] = t16;
    $[63] = t17;
  } else {
    t17 = $[63];
  }
  return t17;
};
function _temp(ev) {
  const target = ev.target as HTMLImageElement;
  target.src = "/media/maker-icons/generic.png";
}
function _temp2(model_0) {
  return model_0.value;
}
function _temp3(m_0) {
  return m_0.value;
}